import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { AuthenticationService } from 'src/app/share-modul/services/authentication/authentication.service';
import { DialogService } from "primeng/dynamicdialog";
import { EditProfileComponent } from "../../../../pos-panel/components/edit-profile/edit-profile.component";
import { TranslateService } from "@ngx-translate/core";
import { UserModel } from "../../../models/user/user.model";
import { NavigationEnd, Router } from "@angular/router";
import { environment } from 'src/environments/environment';
import { OverlayPanel } from 'primeng/overlaypanel';
import { ApplicationId } from 'src/app/share-modul/enums/applicationid.enum';
import { RoleNameEnum } from 'src/app/admin-panel/enums/role-name.enum';

@Component({
  selector: 'app-pos-header',
  templateUrl: './pos-header.component.html',
  styleUrls: ['./pos-header.component.scss']
})
export class PosHeaderComponent implements OnInit, OnDestroy {

  //#region Fields
  public unsubscribe: Subject<void> = new Subject<void>()
  public items: MenuItem[];
  public adminItems: MenuItem[];
  public imagePath: string = 'assets/images/logo/profile-picture-placeholder.png'
  public firstNameLastName: string;
  public email: string;
  public user: UserModel | null;
  public productList: Array<any> = new Array<any>();
  public isAdmin: boolean = true;
  public waiter: boolean;

  @ViewChild('menu_products', { static: false }) menuProducts: OverlayPanel;
  @ViewChild('icon', { static: false }) toggleBtn: ElementRef;
  //#endregion
  //#region Constructor
  constructor(
    public dialogService: DialogService,
    public messageService: MessageService,
    public authenticationService: AuthenticationService,
    public translate: TranslateService,
    public _router: Router,
    public elementRef: ElementRef,
  ) {
    this.translate.stream('HEADER.APP_LANGUAGE').subscribe( () => {
      this.addFunctionToDropdownItems();
    });
  }

  ngOnInit(): void {
    this.authenticationService.loginUser.pipe(takeUntil(this.unsubscribe)).subscribe(user => {
      this.user = user;
      this.loadProfileInfo();
    });

    this.getAllProducts();
  }
  //#endregion

  //#region Public Methods
  logOut() {
    this.authenticationService.loginUser.next(null);
    this.authenticationService._isManager$.next(false);
    this.authenticationService.logout()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          localStorage.removeItem('pos_access_token');
          localStorage.removeItem('refresh_token');
          localStorage.removeItem('waiter_access_token');
          localStorage.removeItem('waiter_refresh_token');

        },
        error: errorResponse => {
          localStorage.removeItem('pos_access_token');
          localStorage.removeItem('refresh_token');
          localStorage.removeItem('waiter_access_token');
          localStorage.removeItem('waiter_refresh_token');
        }
      });
  }

  editProfile() {
    const ref = this.dialogService.open(EditProfileComponent, {
      header: this.translate.instant('HEADER.EDIT_PROFILE'),
      styleClass: 'dialog_long , ml_200, mb_15'
    });
    ref.onClose.subscribe((item: any) => {
      this.loadProfileInfo();
      if (item) {
        let summary = this.translate.instant("HEADER.PROFILE_UPDATED");
        this.messageService.add({severity: 'success', summary, life: 3000});
      }
    });
  }

  loadProfileInfo(): void {
    this.authenticationService.getProfile(this.user?.roles)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.firstNameLastName = response.firstName + ' ' + response.lastName;
          this.email = response.email;
          this.imagePath = response.profilePictureUrl ? response.profilePictureUrl : this.imagePath;
        },
        error: errorResponse => {
        }
      });
  }

  getAllProducts(): void {
    // todo: fetch products
    // test
    this.productList = [
      {
        id: ApplicationId.SocialiteEvents.toString(),
        name: "Socialite Events",
        pictureUrl: "./assets/images/logo/apps/LOGO Socialite Events.png",
        url: environment.URLAdvertiser
      },
      {
        id: ApplicationId.SocialiteResy.toString(),
        name: "Socialite Resy",
        pictureUrl: "./assets/images/logo/apps/LOGO Socialite Resy.png",
        url: environment.URLResy
      },
      ];
  }

  goToProductUrl(url: string){
    const search = '/';
    const replaceWith = '%2F';
    let refreshToken = localStorage.getItem("refresh_token");
    if(refreshToken){
       const result = (localStorage.getItem("refresh_token") as string).split(search).join(replaceWith);
       window.location.href = url+"/login/"+result;
    }
  }

  goToDashboard() {
    const search = '/';
    const replaceWith = '%2F';
    let refreshToken = localStorage.getItem("refresh_token");
    if(refreshToken){
       const result = (localStorage.getItem("refresh_token") as string).split(search).join(replaceWith);
       window.location.href = environment.URLSocialiteManager+"/login/"+result;
    }
  }

  isUserGeneralManager(): boolean | undefined {
    return this.user?.roles.includes(RoleNameEnum.PosGeneralManager);
  }

  addFunctionToDropdownItems(): void {
    this.items = [
      {
        label: this.translate.instant('HEADER.EDIT_PROFILE'),
        icon: 'pi pi-user',
        command: () => {
          this.editProfile();
        }
      },
      {
        label: this.translate.instant('HEADER.LOGOUT'),
        icon: 'pi pi-sign-out',
        command: () => {
          this.logOut();
          this._router.navigate(['login']);
        }
      }
    ];

    this.adminItems = [
      {
        label: this.translate.instant('HEADER.LOGOUT'),
        icon: 'pi pi-sign-out',
        command: () => {
          this.logOut();
          this._router.navigate(['login']);
        }
      }
    ];
  }

  ngOnDestroy(): void {
  }
}
